import React, { useState } from 'react';
import tgIcon from '../images/Telegram_logo.png';
import Image from 'react'

const ChatWidget = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="chat-widget">
      <div className="chat-button" onClick={() => setOpen(prev => !prev)}>💬</div>
      <div className={`circle-container ${open ? 'show' : ''}`}>
        <div className="circle circle_whats" onClick={() => window.location.href = 'https://t.me/parimoskva'}>
          <img src={tgIcon} alt="Telegram" className="circle-icon" />
        </div>

        <div className="circle" onClick={() => window.location.href = 'tel:+79811070307'}>📞</div>
        <div className="circle" onClick={() => document.getElementById('wrapper').scrollIntoView({ behavior: 'smooth' })}>🔗</div>
      </div>
    </div>
  );
};
export default ChatWidget;
